// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JNrIC3i78Hi6Oh1v4SK4 {
    color: #212837;
}

.W073tF3hRWzfsjHSst4F {
    background-color: #5E899B;
}

.hCaO4z45pxESQMtMd7Ku {
    color: #fff;
}

.QXXyihiYXx6cKaB8dZyt {
    color: #45464F;
}

.oER7aQijhKSltJpHclxk {
    background-color: #20354B;
}

.lMafi_ll0WsMEHPjvDfQ {
    color: #F6F4F1;
}

.BOLacOTjOHcs4BoN82mT {
    background-color: #F6F4F1;
}

.fleU0itBbUG4poOiBYQ_ {
    color: #000;
}`, "",{"version":3,"sources":["webpack://./src/colors.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf","sourcesContent":[".gray {\n    color: #212837;\n}\n\n.tealBG {\n    background-color: #5E899B;\n}\n\n.white {\n    color: #fff;\n}\n\n.inputGray {\n    color: #45464F;\n}\n\n.darkBlueBG {\n    background-color: #20354B;\n}\n\n.lightGray {\n    color: #F6F4F1;\n}\n\n.lightGrayBG {\n    background-color: #F6F4F1;\n}\n\n.black {\n    color: #000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gray": `JNrIC3i78Hi6Oh1v4SK4`,
	"tealBG": `W073tF3hRWzfsjHSst4F`,
	"white": `hCaO4z45pxESQMtMd7Ku`,
	"inputGray": `QXXyihiYXx6cKaB8dZyt`,
	"darkBlueBG": `oER7aQijhKSltJpHclxk`,
	"lightGray": `lMafi_ll0WsMEHPjvDfQ`,
	"lightGrayBG": `BOLacOTjOHcs4BoN82mT`,
	"black": `fleU0itBbUG4poOiBYQ_`
};
export default ___CSS_LOADER_EXPORT___;
